import api from "./api/config";

export const orderService = {
  // Tek sayfa sipariş oluşturma (Halı yıkama için)
  createNewOnePageOrder: async (orderData) => {
    try {
      console.log("OrderService: Sipariş oluşturuluyor, data:", orderData);
      
      const response = await api.post("/api/v3/orders/createNewOnePageOrder", orderData);
      console.log("OrderService: Sipariş yanıtı:", response);

      if (response && response.status === 1) {
        return response.data || response;
      } else {
        console.warn("Beklenmeyen sipariş yanıtı yapısı:", response);
        throw new Error(response?.message || "Sipariş oluşturulamadı.");
      }
    } catch (error) {
      console.error("OrderService Error creating order:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Sipariş oluşturulurken bir hata oluştu.";
      throw new Error(errorMessage);
    }
  },

  // Müşterinin siparişlerini getir
  getCustomerOrders: async (customerId) => {
    if (!customerId) {
      throw new Error("Müşteri ID'si gereklidir.");
    }
    try {
      const params = { customerId };
      console.log("OrderService: Siparişler isteniyor, params:", params);
      const response = await api.get("/orders/getCustomerOrders", { params });
      console.log("OrderService: Siparişler yanıtı:", response);

      // Yanıt yapısını kontrol edelim (doğrudan dizi veya {status, data} varsayımı)
      if (Array.isArray(response)) {
        return response;
      } else if (
        response &&
        response.status === 1 &&
        Array.isArray(response.data)
      ) {
        return response.data;
      } else {
        console.warn("Beklenmeyen sipariş yanıtı yapısı:", response);
        return []; // Hata veya beklenmeyen yanıtta boş dizi dön
      }
    } catch (error) {
      console.error("OrderService Error fetching customer orders:", error);
      throw new Error("Siparişler getirilirken bir hata oluştu.");
    }
  },

  // Sipariş detaylarını getir
  getOrderInfo: async (orderId) => {
    if (!orderId) {
      throw new Error("Sipariş ID'si gereklidir.");
    }
    try {
      const params = { orderId };
      console.log("OrderService: Sipariş detayı isteniyor, params:", params);
      
      const response = await api.get("/api/v3/orders/getOrderInfo", {
        params,
      });
      console.log("OrderService: Sipariş detayı yanıtı:", response);

      if (response && response.status === 1 && response.data) {
        return response.data;
      } else {
        console.warn("Beklenmeyen sipariş detayı yanıtı yapısı:", response);
        throw new Error("Sipariş detayları alınamadı.");
      }
    } catch (error) {
      console.error("OrderService Error fetching order info:", error);
      throw new Error("Sipariş detayları getirilirken bir hata oluştu.");
    }
  },

  // Sipariş değerlendirmesi ekle
  addStarPoint: async (evaluationData) => {
    try {
      console.log("OrderService: Değerlendirme ekleniyor, data:", evaluationData);
      
      const response = await api.post("/api/v3/orders/addStarPoint", evaluationData);
      console.log("OrderService: Değerlendirme yanıtı:", response);

      if (response && response.status === 1) {
        return response.data || response;
      } else {
        console.warn("Beklenmeyen değerlendirme yanıtı yapısı:", response);
        throw new Error(response?.message || "Değerlendirme eklenemedi.");
      }
    } catch (error) {
      console.error("OrderService Error adding evaluation:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Değerlendirme eklenirken bir hata oluştu.";
      throw new Error(errorMessage);
    }
  }
};

export default orderService;
